import { useQuery } from '@tanstack/react-query';

import { Envelope, EnvelopeDraft } from '../../../../types';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { SIGNATURE_BASE_PATH } from '../../constants/signatureBasePath';
import { getSignatureDrafts } from '../../requests/getSignatureDrafts';

export const useSignatureDrafts = (
  envelope: Envelope,
  options?: { enabled?: boolean },
) => {
  const { constructGet } = useRequestConstructor();

  const { data, ...rest } = useQuery<
    NonPaginatedResponse<EnvelopeDraft[]> | undefined
  >({
    queryKey: [SIGNATURE_BASE_PATH, 'drafts', envelope.id],
    queryFn: () => getSignatureDrafts(constructGet, envelope),
    staleTime: 10000,
    ...options,
  });

  return { drafts: data?.data, ...rest };
};
